import Style from './style';
import CSSStyle from './style.module.css';

export default function Button({
  additionalButtonProps = {},
  backgroundColor = undefined,
  containerClassName = '',
  containerStyle = {},
  isEnabled = true,
  isHidden = false,
  onClick,
  style = {},
  text = '',
  textColor = undefined,
  type = 'button',
}) {
  if (isHidden) return null;

  function handleClick(e) {
    e.preventDefault();
    onClick();
  }

  return (
    <span className={containerClassName} style={{ ...containerStyle }}>
      <button
        className={CSSStyle.button}
        disabled={!isEnabled}
        style={{ ...Style.button, ...style, backgroundColor, color: textColor }}
        type={type}
        onClick={handleClick}
        {...additionalButtonProps}
      >
        {text}
      </button>
    </span>
  );
}
